function isConnectionNotice(message){return /^(Bağlantı kesildi|Bir hata oluştu\. Bağlantı sorunu)/.test(String(message||''));}
module.exports={isConnectionNotice};
